import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable, SecurityContext, inject } from '@angular/core';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';
import { Observable, map } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class ContentService {
  private readonly http = inject(HttpClient);
  private readonly sanitizer = inject(DomSanitizer);

  public get(path: string): Observable<SafeHtml> {
    const headers = new HttpHeaders({
      'Content-Type': 'text/plain',
    });
    return this.http
      .get(path, {
        headers,
        responseType: 'text',
      })
      .pipe(map((html) => this.sanitizer.sanitize(SecurityContext.HTML, html)));
  }
}
